export const ME = `
  query user {
    user {
      id
      avatar
      dateOfBirth
      bio
      createdAt
      email
      language
      timezone
      username
      twitter
      role
      feedPreference
      rank
      rankPoints
      rankMedals {
        top1
        top2
        top3
      }
    }
  }
`;

export const USER_BY_FACEBOOK_API = `
  query userByFacebookApi($accessToken: String!) {
    userByFacebookApi(accessToken: $accessToken) {
      birthday
      name
      email
      userId
  }
}`;

export const USER_BY_GOOGLE_API = `
  query userByGoogleApi($code: String!) {
    userByGoogleApi(code: $code) {
      idToken
      birthday
      name
      email
      userId
  }
}`;

export const USER_EMAIL_EXIST = `
  query userEmailExist($email: String!) {
    userEmailExist(email: $email)
  }
`;

export const USERS_STAT = `
  query usersStat {
    usersStat {
      userEnrolled
      userEnrolledByDay
      userEnrolledByWeek
    }
  }
`;

export const USER_USERNAME_EXIST = `
  query userUsernameExist($username: String!) {
    userUsernameExist(username: $username)
  }
`;

const USER_ADMIN_FIELDS = `
  id
  avatar
  bio
  connectedAt
  connectedWith
  createdAt
  dateOfBirth
  deletedAt
  email
  fcmPermissionStatus
  language
  timezone
  username
  versionApple
  versionAndroid
`;

export const USERS_ADMIN_PAGINATION = `
  query usersAdminPagination($input: UserAdminPaginationInput) {
    usersAdminPagination(input: $input) {
      docs {
        ${USER_ADMIN_FIELDS}
      }
      totalDocs
      offset
      limit
      hasNextPage
    }
  }
`;

// Admin: suspended accounts are returned too.
export const USER_ADMIN_BY_ID = `
  query userAdminById($id: ID!) {
    userById(id: $id) {
      ${USER_ADMIN_FIELDS}
    }
  }
`;

export const USERS_SEARCH_FOR_NOTIFICATION = `
  query usersSearch($search: String) {
    usersSearch(search: $search) {
      id
      avatar
      connectedWith
      email
      fcmPermissionStatus
      username
      versionApple
      versionAndroid
    }
  }
`;

export const USER_FOR_NOTIFICATION = `
  query userById($id: ID!) {
    userById(id: $id) {
      id
      avatar
      connectedWith
      email
      fcmPermissionStatus
      username
      versionApple
      versionAndroid
    }
  }
`;

export const USER_BY_ID = `
  query userById($id: ID!) {
    userById(id: $id) {
      id
      avatar
      bio
      isFollowed
      rank
      username
    }
  }
`;

// Users to propose while typing @ in a comment (prefix of the username, followed users first).
export const MENTION_SUGGESTIONS = `
  query mentionSuggestions($search: String!, $limit: Int, $offset: Int) {
    mentionSuggestions(search: $search, limit: $limit, offset: $offset) {
      id
      avatar
      username
      rank
    }
  }
`;
